import React, { useState } from "react";
import { DownloadIcon, DropdownCrossIcon, EditIcon, FileIcon } from "../../../Icons";
import {
  FormatBalance,
  FormatDate,
  GetTransactionsTypeIcon,
} from "../../../../helper";
import SecondaryButton from "../../../Buttons/SecondaryButton";
import { useSelector } from "react-redux";
import HelpModal from "../../../Modals/HelpModal";
import GetTransactionStatus from "./partials/GetTransactionStatus";
import { useNavigate } from "react-router-dom";
import TopupCardModal from "../../../Modals/Card/ToupCardModal";
import useModules from "../../../../hooks/useModules";
import EditTransactionButton from "./partials/EditTransactionButton";
import ViewFileButton from "../../../Buttons/ViewFileButton";
import CommonButton from "../../../Buttons/CommonButton";

const ViewRecentTransaction = ({
  transaction,
  setShowRecentTransaction,
  setActiveTransaction,
  type = "accounts",
  fetchTopups,
  handledDownloadStatement,
}) => {
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const { currency_code, is_crypto, is_sepa } = useSelector(
    (state) => state.activeAccount.activeAccount
  );
  const { activeCard } = useSelector((state) => state.activeCard);

  const isCrypto = useModules("Crypto");
  const isBitpace = useModules("Bitpace");

  const handleOpenUrl = (item) => {
    let url = "";
    let isObjectUrl = false;

    if (item instanceof Blob || item instanceof File) {
      url = URL.createObjectURL(item);
      isObjectUrl = true;
    } else if (typeof item === "string") {
      url = item;
    } else if (item?.url) {
      url = item.url;
    }

    if (!url) return;

    // Fix C-TAB-01: prevent reverse tabnabbing
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");

    // Reset opener reference defensively
    if (newWindow) {
      newWindow.opener = null;
    }

    // Revoke generated object URL after the tab opens to prevent memory leaks
    if (isObjectUrl) {
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    }
  };

  const navigate = useNavigate();

  const handleTransactionClick = (transaction) => {
    switch (transaction.nature) {
      case "Withdraw":
        navigate("/crypto-withdraw", { state: { transaction: transaction } });
        break;
      case "Sell":
        navigate("/crypto-sell", { state: { transaction: transaction } });
        break;
      case "Buy":
        navigate("/crypto-buy", { state: { transaction: transaction } });
        break;
      case "TT":
        if (transaction.beneficiary_id) {
          navigate("/transfer", { state: { transaction: transaction } });
        } else {
          navigate("/deposit", { state: transaction.id });
        }
        break;
      case "Internal":
        navigate("/transfer", { state: { transaction: transaction } });
        break;
      default:
        break;
    }
  };

  const handleIsCryptoEnabled = () => {
    const { nature } = transaction;
    if (isCrypto && isBitpace && ["Buy", "Sell", "Withdraw"].includes(nature)) {
      return null;
    }
    if (nature === "Top-up" && activeCard.status === "Active") {
      return (
        <TopupCardModal
          activeCard={activeCard}
          transaction={transaction}
          setActiveTransaction={setActiveTransaction}
          refreshTable={fetchTopups}
        >
          <CommonButton>
            <div className="flex items-center justify-center">
              <EditIcon />
              Edit Transaction
            </div>
          </CommonButton>
        </TopupCardModal>
      );
    }
    if (
      ["TT", "Internal"].includes(nature) ||
      (isCrypto && !isBitpace && nature !== "Top-up")
    ) {
      return (
        <EditTransactionButton
          handleTransactionClick={handleTransactionClick}
          transaction={transaction}
        />
      );
    }

    return null;
  };

  const getCurrenySumbolFromAccountTitle = (account_title) => {
    let currency = account_title.split("(")[1];
    currency = currency.split(")")[0];
    // return GetCurrenySymbol(currency, "13", "13");
    return currency;
  };

  return (
    <>
      <div
        onClick={() => {
          setShowRecentTransaction(false);
          setActiveTransaction(null);
        }}
      >
        <div className="hover:bg-background-hover rounded-full w-6 h-6 p-4 flex items-center justify-center cursor-pointer">
          <DropdownCrossIcon className="" />
        </div>
      </div>
      <div className={`view-recent-transaction-amount ${ transaction.status === "Rejected" && "view-recent-transaction-amount-rejected" } `}>
        <div className="space-x-2 mx-2 flex items-center">
          <span>{transaction.type === "Credit" ? "+" : "-"}</span>

          {/* {type === "card" ? GetCurrenySymbol(activeCard.currency ? activeCard.currency : "USD") : GetCurrenySymbol(currency_code)} */}

          <span>
            {type === "card"
              ? transaction.account_title
                ? getCurrenySumbolFromAccountTitle(transaction.account_title)
                : "USD"
              : currency_code}
          </span>
          <span>
            {is_crypto && transaction.crypto_amount
              ? FormatBalance(transaction.crypto_amount, is_crypto)
              : FormatBalance(transaction.amount)}
          </span>
        </div>
      </div>

      <div className="view-recent-transaction-info">
        {GetTransactionsTypeIcon(type, transaction.type)}

        <div className="flex-col justify-start items-start inline-flex w-64">
          <p className="view-recent-transaction-remarks">
            {transaction.remarks}
          </p>
          <div className="flex-col justify-center items-center gap-2.5 flex">
            <div className="view-recent-transaction-date">
              {FormatDate(transaction.date, "d m, yyyy", "h:M a")}
            </div>
          </div>
        </div>
      </div>
      <div className="view-recent-transaction-details">
        {transaction.status && (
          <div className="flex items-start justify-between py-4">
            <p className="view-recent-transaction-list-title">
              Status
            </p>
            <div className="view-recent-transaction-list-get-transaction-status">
              <GetTransactionStatus status={transaction.status} />
            </div>
          </div>
        )}

        {transaction.status === "Rejected" && (
          <ListItem title="Rejected Reason" value={transaction.reject_reason} />
        )}
        <ListItem title="Type" value={transaction.type} />
        <ListItem title="Transaction ID" value={transaction.id} />
        <ListItem title="Nature" value={transaction.nature} />
        {type === "card" && transaction.account_title && (
          <ListItem title="From account" value={transaction.account_title} />
        )}
        <ListItem title="Remarks" value={transaction.remarks} />
        {transaction && transaction.docs && transaction.docs.length > 0 && (
          <div>
            {/* Check if any non-payment documents exist */}
            {transaction.docs.some((doc) => doc.is_payment !== "1") && (
              <>
                <ListItem title="Supporting Documents" />
                <div className="grid grid-cols-3">
                  {transaction.docs.map((doc) =>
                    doc.is_payment !== "1" ? (
                      <div key={doc.id || doc.url} className="mb-4">
                        <ViewFileButton
                          text="View"
                          onClick={() => handleOpenUrl(doc.url)}
                          icon={<FileIcon />}
                        />
                      </div>
                    ) : null
                  )}
                </div>
              </>
            )}

            {/* Check if any payment documents exist */}
            {transaction.docs.some((doc) => doc.is_payment === "1") && (
              <>
                <ListItem title="Payment Advice Document" />
                <div className="grid grid-cols-3">
                  {transaction.docs.map((doc) =>
                    doc.is_payment === "1" ? (
                      <div key={doc.id || doc.url} className="mb-4">
                        <ViewFileButton
                          text="View"
                          onClick={() => handleOpenUrl(doc.url)}
                          icon={<FileIcon />}
                        />
                      </div>
                    ) : null
                  )}
                </div>
              </>
            )}
          </div>
        )}
        {is_sepa && transaction.status !== "Pending" && transaction.is_openpayd_trn && (
          <>
            <ListItem title="Download PDF" />
            <div className="grid grid-cols-3">
              <div className="mb-4">
                <ViewFileButton
                  text="Download"
                  onClick={() => handledDownloadStatement(transaction.id)}
                  icon={<DownloadIcon />}
                />
              </div>
            </div>
          </>
        )}
      </div>

      <HelpModal
        HelpModalOpen={helpModalOpen}
        setHelpModalOpen={setHelpModalOpen}
      >
        <SecondaryButton text="Get Help" />
      </HelpModal>
      {transaction.status === "Rejected" && handleIsCryptoEnabled()}
    </>
  );
};

const ListItem = ({ title, value }) => {
  return (
    <div className="flex items-start justify-between py-4 gap-3">
      <p className="view-recent-transaction-list-title">
        {title}
      </p>
      <p className="view-recent-transaction-list-value">
        {value}
      </p>
    </div>
  );
};

export default ViewRecentTransaction;
